import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
export const SmartSendItemsCache: SmartSendItemApiModel[] = [];
